import { HubRoute, RouteReassignment, HubWorkstation } from '@/types/hub'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface State {
    workstation: Omit<HubWorkstation, 'routes' | 'routeReassignments'> | null
    routes: HubRoute[]
    reassignedRoutes: RouteReassignment[]
}

interface Actions {
    setWorkstation: (workstation: State['workstation']) => void
    setRoutes: (routes: State['routes']) => void
    setReassignedRoutes: (reassignedRoutes: State['reassignedRoutes']) => void
    clear: () => void
}

export const useWorkstationStore = create<State & Actions>()(
    persist(
        (set) => ({
            workstation: null,
            routes: [],
            reassignedRoutes: [],
            setWorkstation: (workstation) => set({ workstation }),
            setRoutes: (routes) => set({ routes }),
            setReassignedRoutes: (reassignedRoutes) => set({ reassignedRoutes }),
            clear: () =>
                set({
                    workstation: null,
                    routes: [],
                    reassignedRoutes: [],
                }),
        }),
        {
            name: 'workstation-storage',
        }
    )
)

interface RoutesStore {
    routes: HubRoute[]
}

interface RouteActions {
    setRoutes: (routes: HubRoute[]) => void
    clear: () => void
}

export const useRoutesChangedStore = create<RoutesStore & RouteActions>((set) => ({
    routes: [],
    setRoutes: (routes) => set({ routes }),
    clear: () => set({ routes: [] }),
}))

interface SharedRoutesStore {
    sharedRoutes: HubRoute[]
}

interface SharedRouteActions {
    setSharedRoutes: (routes: HubRoute[]) => void
    clear: () => void
}

export const useSharedRoutesStore = create<SharedRoutesStore & SharedRouteActions>((set) => ({
    sharedRoutes: [],
    setSharedRoutes: (sharedRoutes) => set({ sharedRoutes }),
    clear: () => set({ sharedRoutes: [] }),
}))
